import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TextLibraryPayload, TextLibraryState } from './types';

export const textLibraryInitialState: TextLibraryState = {
  title: undefined,
  entries: [],
  includeTitle: true,
};

export const slice = createSlice({
  name: 'textLibrary',
  initialState: textLibraryInitialState,
  reducers: {
    setTextLibraryAction: (state: TextLibraryState, action: PayloadAction<TextLibraryPayload>) => {
      state.title = action.payload.title;
      state.entries = action.payload.entries;
      state.includeTitle = action.payload.includeTitle ?? true;
    },
  },
});

export const { setTextLibraryAction } = slice.actions;

export default slice.reducer;
